import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// SVG Icons
const Icons = {
  Dashboard: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" /></svg>,
  Test: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" /></svg>,
  Subscription: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" /></svg>,
  College: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-3m-6 3v-3" /></svg>,
  History: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2z" /></svg>,
  Performance: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" /></svg>,
  Settings: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>,
  Faq: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>,
  Help: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.9l-3.536 3.535M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>,
  Register: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" /></svg>,
  Logout: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" /></svg>,
};

const SidebarLink = ({ icon, label, to, active }) => (
  <Link to={to} className={`flex items-center gap-3 p-3 rounded-xl transition-all ${
    active
      ? 'bg-accent-gold text-black font-medium shadow-lg shadow-accent-gold/20'
      : 'text-text-muted hover:text-white hover:bg-white/10'
  }`}>
    {icon} <span>{label}</span>
  </Link>
);

const DashboardSidebar = ({ mobileOpen, onMobileClose }) => {
  const { logout } = useAuth();
  const navigate    = useNavigate();
  const location    = useLocation();
  const path        = location.pathname;

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const navItems = [
    { icon: <Icons.Dashboard />,    label: 'Dashboard',               to: '/dashboard' },
    { icon: <Icons.Register />,     label: 'CUET UG Mock Registration', to: '/cuet-mock' },
    { icon: <Icons.Test />,         label: 'Test Zone',               to: '/test-zone' },
    { icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" /></svg>,  label: 'Study Materials', to: '/my-study-materials' },
    { icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>,  label: 'PYQ Papers',      to: '/my-pyq' },
    { icon: <Icons.History />,      label: 'Purchase History',        to: '/purchase-history' },
    { icon: <Icons.Performance />,  label: 'Performance',             to: '/performance' },
    { icon: <Icons.Settings />,     label: 'Settings',                to: '/settings' },
  ];

  const bottomItems = [
    { icon: <Icons.Subscription />, label: 'Subscriptions',   to: '/subscriptions' },
    { icon: <Icons.College />,      label: 'Search Colleges', to: '/search-colleges' },
    { icon: <Icons.Faq />,          label: 'FAQ',             to: '/faq' },
    { icon: <Icons.Help />,         label: 'Help & Support',  to: '/contact' },
  ];

  return (
    <aside className={`fixed z-40 md:static md:block md:h-[calc(100vh-6rem)] md:top-24 top-20 left-0 h-[calc(100vh-5rem)] w-64 bg-white/5 backdrop-blur-xl border-r border-white/10 transition-transform duration-300 flex-shrink-0 ${
      mobileOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'
    }`}>

      {/* Mobile close */}
      <div className="p-6 border-b border-white/10 flex items-center justify-between md:hidden">
        <span className="font-bold text-xl tracking-wider text-white">Menu</span>
        <button className="text-white text-xl" onClick={onMobileClose}>✕</button>
      </div>

      <nav className="p-4 overflow-y-auto h-full flex flex-col">
        {/* Main nav */}
        <div className="flex-1 space-y-1">
          {navItems.map(item => (
            <SidebarLink
              key={item.to}
              icon={item.icon}
              label={item.label}
              to={item.to}
              active={path === item.to}
            />
          ))}

          <div className="pt-4 border-t border-white/10 mt-4 space-y-1">
            {bottomItems.map(item => (
              <SidebarLink
                key={item.to}
                icon={item.icon}
                label={item.label}
                to={item.to}
                active={path === item.to}
              />
            ))}
          </div>
        </div>

        {/* Logout + legal */}
        <div className="mt-4 pt-4 border-t border-white/10">
          <button
            onClick={handleLogout}
            className="flex items-center gap-3 p-3 rounded-xl w-full text-red-400 hover:text-red-300 hover:bg-red-500/10 transition-all"
          >
            <Icons.Logout /> <span>Logout</span>
          </button>
          <div className="px-4 mt-3 text-xs text-text-muted flex gap-2 flex-wrap">
            <Link to="/privacy-policy" className="hover:text-accent-gold">Privacy Policy</Link>
            <span>•</span>
            <Link to="/terms" className="hover:text-accent-gold">Terms of Use</Link>
          </div>
        </div>
      </nav>
    </aside>
  );
};

// Wrapper layout used by Dashboard, TestZone, Settings, Performance, etc.
export const DashboardLayout = ({ children, title }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#1a0b2e] bg-gradient-to-br from-[#1a0b2e] via-[#2d1b4e] to-[#1a0b2e] text-white flex pt-24">
      <DashboardSidebar mobileOpen={sidebarOpen} onMobileClose={() => setSidebarOpen(false)} />
      <main className="flex-1 overflow-x-hidden overflow-y-auto h-[calc(100vh-6rem)]">
        <div className="md:hidden p-4 flex items-center justify-between bg-white/5 backdrop-blur-md sticky top-0 z-30 mb-4 rounded-b-xl">
          <button onClick={() => setSidebarOpen(true)} className="text-white">☰ Menu</button>
          <span className="font-bold text-white">{title || 'Dashboard'}</span>
        </div>
        {children}
      </main>
    </div>
  );
};

export default DashboardSidebar;
